<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <g transform="translate(-14 -555)">
      <text class="question-a" transform="translate(21 556)">
        <tspan x="0" y="14">?</tspan>
      </text>
      <g class="question-b" transform="translate(14 555)">
        <circle class="question-c" cx="10" cy="10" r="10"/>
        <circle class="question-d" cx="10" cy="10" r="9"/>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'QuestionIcon'
}
</script>

<style scoped>
svg .question-a {
  fill: #FFFFFF;
  font-size: 13px;
  font-weight: 700;
}

svg .question-b, .question-d {
  fill: none;
}

svg .question-b {
  stroke: #FFFFFF;
  stroke-width: 2px;
}

svg .question-c {
  stroke: none;
}
</style>
